import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmInfos } from '../../lawFirm.types';
import {
  DomainFlattened,
  Juridiction,
  Ville,
  Lawyer,
} from '../../../entity/entity.types';
import { LawFirmDescription } from '../description/LawFirmDescription';
import { fetchLawyersByOffice } from '../../lawFirm.api';
import { LawFirmClients } from '../LawFirmClients';
import { FirmTopDecisions } from '../FirmTopDecisions';
import { LawFirmTop } from '../header/LawFirmTop';
import { LawyersInOffice } from '../LawyersInOffice';
import { LawFirmCases } from '../LawFirmCases';
import { UniqueLawFirmHeader } from './UniqueLawFirmHeader';
import { UserContextType } from '../../../user/user.types';
import { PageCenter } from '../../../components/page/Page';
import { LoaderWithText } from '../../../components/loader/LoaderWithText';
import {
  EntityCardContainer,
  EntityCardHeader,
  EntityCardItem,
} from '../../../entity/components/EntityCardComponents';

type Props = {
  lawFirmInfos: LawFirmInfos;
  accessPremium: UserContextType['accessPremium'];
  loggedIn: UserContextType['loggedIn'];
  experience: {
    domains: Array<DomainFlattened>;
    juridictions: Array<Juridiction>;
    villes: Array<Ville>;
    decisionCount: number;
  };
  loaded: boolean;
  allDecisionsLink: string;
};

type State = {
  lawyers: Array<Lawyer>;
};

export class UniqueLawFirm extends React.Component<Props, State> {
  state: State = {
    lawyers: [],
  };

  async componentDidMount() {
    const {
      lawFirmInfos: { lawOfficeId, offices },
    } = this.props;
    const { lawyers } = (
      await fetchLawyersByOffice(lawOfficeId, offices[0].nic)
    ).data;
    this.setState({ lawyers });
    window.dispatchEvent(new CustomEvent('showNav', { detail: true }));
  }

  render() {
    const {
      allDecisionsLink,
      lawFirmInfos: { name, lawOfficeIdGroup, dateRadiation, offices },
      accessPremium,
      loggedIn,
      experience,
      experience: { decisionCount, domains, juridictions, villes },
      loaded,
    } = this.props;
    const { lawyers } = this.state;

    const source = 'uniqueLawFirm';
    if (!loaded) {
      return (
        <PageCenter>
          <EntityCardHeader>
            <LawFirmTop name={name} />
          </EntityCardHeader>
          <EntityCardContainer>
            <EntityCardItem>
              <LoaderWithText>
                <FormattedMessage id="law-firm/page/unique/UniqueLawFirm.tsx/1" />
              </LoaderWithText>
            </EntityCardItem>
          </EntityCardContainer>
        </PageCenter>
      );
    }

    return (
      <PageCenter>
        <UniqueLawFirmHeader
          firmName={name}
          dateRadiation={dateRadiation}
          decisionCount={decisionCount}
          allDecisionsLink={allDecisionsLink}
          office={offices[0]}
          lawOfficeIdGroup={lawOfficeIdGroup}
        />
        <FirmTopDecisions
          lawOfficeIdGroup={lawOfficeIdGroup}
          decisionCount={decisionCount}
          allDecisionsLink={allDecisionsLink}
          firmName={name}
        />
        {lawyers.length > 0 && (
          <LawyersInOffice
            isBranchOffice={false}
            lawyers={lawyers}
            source={source}
            accessPremium={accessPremium}
          />
        )}
        <LawFirmDescription
          pageName={`le cabinet ${name}`}
          hasExperience={
            domains.length > 0 || juridictions.length > 0 || villes.length > 0
          }
          decisionCount={decisionCount}
        />
        {(domains.length > 0 ||
          juridictions.length > 0 ||
          villes.length > 0) && (
          <LawFirmCases
            experience={experience}
            lawOfficeIdGroup={lawOfficeIdGroup}
            lawFirmName={name}
          />
        )}
        <LawFirmClients
          lawOfficeIdGroup={lawOfficeIdGroup}
          name={name}
          loggedIn={loggedIn}
          decisionCount={decisionCount}
        />
      </PageCenter>
    );
  }
}
